import { useContext } from 'react'
import { App } from 'antd'
import { useIntl } from 'react-intl'
import * as logger from '../../../../services/logger'
import { postCoreEvent } from '../../../../services/core-event'
import { notificationStore } from '../../../../context/notificationsContext/store'
import { showApiErrorNotification } from '../showApiErrorNotification'
import { IUserFilteredInfo } from '../../../../types/users'

export interface IOptimisticUserEventParams {
  userId: string
  eventBody: Record<string, unknown>
  patch: Partial<IUserFilteredInfo>
  inversePatch: Partial<IUserFilteredInfo>
}

export interface IUseOptimisticUserEventParams {
  patchUser: (userId: string, patch: Partial<IUserFilteredInfo>) => void
}

export function useOptimisticUserEvent({ patchUser }: IUseOptimisticUserEventParams) {
  const { formatMessage } = useIntl()
  const { notification } = App.useApp()
  const { addActionNotifications } = useContext(notificationStore)

  return async (params: IOptimisticUserEventParams): Promise<void> => {
    const { userId, eventBody, patch, inversePatch } = params

    patchUser(userId, patch)
    let response: { correlationId: string }
    try {
      response = await postCoreEvent(eventBody, 'users-table')
    } catch (error) {
      patchUser(userId, inversePatch)
      logger.warning({ errorType: 'ERROR INLINE USER EDIT', error })
      showApiErrorNotification(notification, formatMessage, error)
      throw error
    }

    addActionNotifications([response.correlationId])
  }
}
